import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {isCodeCatalogEnabled} from '@app/utils/environment-features';

export const codeCatalogGuard: CanActivateFn = () => {
  if (isCodeCatalogEnabled()) {
    return true;
  }
  return inject(Router).createUrlTree(['/admin/orchestration']);
};
